<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>Admin</li>
        <li>공지사항</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>공지사항</h2>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <h3 class="conTit">공지사항</h3>

        <div class="noticeInfo">
          <dl>
            <dt>글번호</dt>
            <dd>
              <p>{{ state.notice.SEQ }}</p>
            </dd>
          </dl>
          <dl>
            <dt>기간</dt>
            <dd style="display: flex">
              <div class="form_input_area type_calendar" style="width: 47%">
                <datepicker
                  v-model="state.notice.strt_ymd"
                  :locale="ko"
                  class="form_input"
                  inputFormat="yyyy-MM-dd"
                  @blur="dateUpt(this)"
                  ref="strt_ymd"
                />
                <button type="button" class="btn_calendar">
                  <span>날짜선택</span>
                </button>
              </div>
              <span style="margin: 13px 0px 0px 10px">~</span>
              <div class="form_input_area type_calendar" style="width: 46%">
                <datepicker
                  v-model="state.notice.fin_ymd"
                  :locale="ko"
                  class="form_input"
                  inputFormat="yyyy-MM-dd"
                  :inputonly="inputOnly"
                />
                <button type="button" class="btn_calendar">
                  <span>날짜선택</span>
                </button>
              </div>
            </dd>
          </dl>
          <dl>
            <dt>팝업여부</dt>
            <dd>
              <div class="inpCheck">
                <input
                  type="checkbox"
                  id="popChk"
                  v-model="state.notice.NOTICE_TYP"
                  :checked="state.notice.NOTICE_TYP == '1' ? true : false"
                />
                <label for="popChk" class="pdl20"
                  ><span class="hide">팝업여부선택</span></label
                >
              </div>
            </dd>
          </dl>
          <dl>
            <dt>글제목</dt>
            <dd>
              <input type="text" id="popChk" v-model="state.notice.SUBJECT" />
            </dd>
          </dl>
        </div>

        <div class="tabStyle2">
          <table>
            <caption>
              공지사항 내용
            </caption>
            <colgroup>
              <col width="*" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" height="62">내용</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="noticeView">
                  <textarea
                    id="noticeTextArea"
                    class="text_area protect"
                    v-model="state.notice.CONTENT"
                  ></textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="btnWrap">
          <a
            @click="notiDel(state.notice.SEQ)"
            v-show="state.authUC == 'U'"
            class="btnType sizeR colorBL"
            ><span>삭제</span></a
          >
          <a
            @click="notiUpt(state.notice)"
            v-show="state.authUC == 'U'"
            class="btnType sizeR colorB"
            ><span>수정</span></a
          >
          <a
            @click="notiSave(state.notice)"
            v-show="state.authUC == 'C'"
            class="btnType sizeR colorB"
            ><span>저장</span></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import { globalState } from "@/common/globalState";
import Datepicker from "vue3-datepicker";
import { ko } from "date-fns/locale";

const picked = ref(new Date());
const swalAlert = inject("swalAlert");
const handlePopupClose = () => {};
const PopNotiRef = ref(null);
const router = useRouter();
const store = useStore();
const axios = inject("axios");
const inputOnly = ref("readonly");
const state = reactive({
  currDateFormat: util.formatDate(new Date(), "yyyy-mm-dd"),
  authUC: "U",
  notice: {},
  seq: "",
});

onMounted(async () => {
  await axios.json("/getMaxSeq.do", {}).then(function (result) {
    if (store.state.common.seq == result.data.seq) {
      state.notice.SEQ = result.data.seq;
      state.notice.strt_ymd = new Date(state.currDateFormat);
      state.notice.fin_ymd = new Date(state.currDateFormat);
      state.authUC = "C";
    }
  });
  if (state.authUC == "U") {
    const param = {};
    param.seq = store.state.common.seq;
    axios.json("/noticePop.do", param).then(function (result) {
      state.notice = result.data.notice;
      state.notice.strt_ymd = new Date(result.data.notice.STRT_YMD);
      state.notice.fin_ymd = new Date(result.data.notice.FIN_YMD);
    });
  }
  const inputRef = inputOnly.value;
  console.log(inputRef);
});

const notiDel = (item) => {
  return swalAlert("정말로 삭제하시겠습니까?").then((result) => {
    if (result.value) {
      const param = {};
      param.seq = item;
      axios.json("/delNotice.do", param).then(function (result) {
        axios.json("/logHisLdg.do", { memo: "공지사항삭제" });
        swalAlert(result.data.msg).then((result) => {
          router.push({ name: "noticeBd" });
        });
      });
    }
  });
};

const dateUpt = (o) => {
  console.log(o.$refs.strt_ymd.input);
};

const notiUpt = (item) => {
  if (_.isEmpty(item.SUBJECT)) {
    return swalAlert("글제목은 필수입니다.");
  } else if (_.isEmpty(item.CONTENT)) {
    return swalAlert("내용은 필수입니다.");
  } else if (new Date(item.strt_ymd) > new Date(item.fin_ymd)) {
    return swalAlert("시작일자가 종료일자보다 이전날자로 선택하세요.");
  }
  const param = {};
  param.seq = store.state.common.seq;
  param.subject = item.SUBJECT;
  param.content = item.CONTENT;
  param.strt_ymd = util.formatDate(item.strt_ymd, "yyyy-mm-dd");
  param.fin_ymd = util.formatDate(item.fin_ymd, "yyyy-mm-dd");
  param.notice_typ = item.NOTICE_TYP ? "1" : "0";
  axios
    .json("/uptNotice.do", param)
    .then(function (result) {
      axios.json("/logHisLdg.do", { memo: "공지사항수정" });
      swalAlert(result.data.msg).then((result) => {
        router.push({ name: "noticeBd" });
      });
    })
    .catch(function (err) {
      // console.log(err);
      alert("저장할수 없는 형식입니다.");
      return;
    });
};

const notiSave = (item) => {
  if (_.isEmpty(item.SUBJECT)) {
    return swalAlert("글제목은 필수입니다.");
  } else if (_.isEmpty(item.CONTENT)) {
    return swalAlert("내용은 필수입니다.");
  } else if (new Date(item.strt_ymd) > new Date(item.fin_ymd)) {
    return swalAlert("시작일자가 종료일자보다 이전날자로 선택하세요.");
  }

  const param = {};
  param.seq = item.SEQ;
  param.subject = item.SUBJECT;
  param.content = item.CONTENT;
  param.strt_ymd = util.formatDate(item.strt_ymd, "yyyy-mm-dd");
  param.fin_ymd = util.formatDate(item.fin_ymd, "yyyy-mm-dd");
  param.notice_typ = item.NOTICE_TYP ? "1" : "0";
  axios
    .json("/insertNotice.do", param)
    .then(function (result) {
      axios.json("/logHisLdg.do", { memo: "공지사항신규등록" });
      swalAlert(result.data.msg).then((result) => {
        router.push({ name: "noticeBd" });
      });
    })
    .catch(function (err) {
      // console.log(err);
      alert("저장할수 없는 형식입니다.");
      return;
    });
};
</script>

<style></style>
